import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/tickets.literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class TicketsLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  ticketActions$ = this.storeSelect(selectors.getTicketActions);
  ticketID$ = this.storeSelect(selectors.getTicketID);
  ticketSeverity$ = this.storeSelect(selectors.getTicketSeverity);
  ticketLoyaltySchema$ = this.storeSelect(selectors.getTicketLoyaltySchema);
  ticketStatus$ = this.storeSelect(selectors.getTicketStatus);
  ticketCountry$ = this.storeSelect(selectors.getTicketCountry);
  ticketCategory$ = this.storeSelect(selectors.getTicketCategory);
  ticketAssignee$ = this.storeSelect(selectors.getTicketAssignee);
  ticketSearchBody$ = this.storeSelect(selectors.getTicketSearchBody);
  ticketSubject$ = this.storeSelect(selectors.getTicketSubject);
  ticketCreationDate$ = this.storeSelect(selectors.getTicketCreationDate);
  ticketInitiator$ = this.storeSelect(selectors.getTicketInitiator);
  sortCustomer$ = this.storeSelect(selectors.getSortCustomer);
  sortId$ = this.storeSelect(selectors.getSortId);
  sortInitiationDate$ = this.storeSelect(selectors.getSortInitiationDate);
  sortInitiator$ = this.storeSelect(selectors.getSortInitiator);
  sortLoyaltySchema$ = this.storeSelect(selectors.getSortLoyaltySchema);
  sortSubject$ = this.storeSelect(selectors.getSortSubject);
  sortTableTicketAssignee$ = this.storeSelect(selectors.getSortTableTicketAssignee);
  sortTableTicketCategory$ = this.storeSelect(selectors.getSortTableTicketCategory);
  sortTableTicketSeverity$ = this.storeSelect(selectors.getSortTableTicketSeverity);
  sortTableTicketStatus$ = this.storeSelect(selectors.getSortTableTicketStatus);
  createTicket$ = this.storeSelect(selectors.getCreateTicket);
  executeFlow$ = this.storeSelect(selectors.getExecuteFlow);
  flows$ = this.storeSelect(selectors.getFlows);
  associateCustomer$ = this.storeSelect(selectors.getAssociateCustomer);
  clearCustomer$ = this.storeSelect(selectors.getClearCustomer);
  schema$ = this.storeSelect(selectors.getSchema);
  fullName$ = this.storeSelect(selectors.getFullName);
  body$ = this.storeSelect(selectors.getBody);
  cancelTicket$ = this.storeSelect(selectors.getCancelTicket);
  ticket$ = this.storeSelect(selectors.getTicket);
  memberNotFound$ = this.storeSelect(selectors.getMemberNotFound);
  editTicketHeader$ = this.storeSelect(selectors.getEditTicketHeader);
  resolve$ = this.storeSelect(selectors.getResolve);
  massInsertion$ = this.storeSelect(selectors.getMassInsertion);
  resolveHeader$ = this.storeSelect(selectors.getResolveHeader);
  resolveDescription$ = this.storeSelect(selectors.getResolveDescription);
  uploadButton$ = this.storeSelect(selectors.getUploadButton);
  dragAndDrop$ = this.storeSelect(selectors.getDragAndDrop);
  uploadedFile$ = this.storeSelect(selectors.getUploadedFile);
  uploadedFileEmpty$ = this.storeSelect(selectors.getUploadedFileEmpty);
  massActionsEmail$ = this.storeSelect(selectors.getMassActionsEmail);
  resolveBtn$ = this.storeSelect(selectors.getResolveBtn);
  notificationEmail$ = this.storeSelect(selectors.getNotificationEmail);
  insertTickets$ = this.storeSelect(selectors.getInsertTickets);

  // OBSERVABLE'S VALUES
  get ticketActions() {
    return this.storeSnapshot(this.ticketActions$);
  }

  get sortCustomer() {
    return this.storeSnapshot(this.sortCustomer$);
  }

  get sortId() {
    return this.storeSnapshot(this.sortId$);
  }

  get sortInitiationDate() {
    return this.storeSnapshot(this.sortInitiationDate$);
  }

  get sortInitiator() {
    return this.storeSnapshot(this.sortInitiator$);
  }

  get sortLoyaltySchema() {
    return this.storeSnapshot(this.sortLoyaltySchema$);
  }

  get sortSubject() {
    return this.storeSnapshot(this.sortSubject$);
  }

  get sortTableTicketAssignee() {
    return this.storeSnapshot(this.sortTableTicketAssignee$);
  }

  get sortTableTicketCategory() {
    return this.storeSnapshot(this.sortTableTicketCategory$);
  }

  get sortTableTicketSeverity() {
    return this.storeSnapshot(this.sortTableTicketSeverity$);
  }

  get sortTableTicketStatus() {
    return this.storeSnapshot(this.sortTableTicketStatus$);
  }

  get ticketID() {
    return this.storeSnapshot(this.ticketID$);
  }

  get ticketStatus() {
    return this.storeSnapshot(this.ticketStatus$);
  }

  get ticketInitiator() {
    return this.storeSnapshot(this.ticketInitiator$);
  }

  get ticketAssignee() {
    return this.storeSnapshot(this.ticketAssignee$);
  }

  get ticketSeverity() {
    return this.storeSnapshot(this.ticketSeverity$);
  }

  get ticketCategory() {
    return this.storeSnapshot(this.ticketCategory$);
  }

  get ticketLoyaltySchema() {
    return this.storeSnapshot(this.ticketLoyaltySchema$);
  }

  get ticketSubject() {
    return this.storeSnapshot(this.ticketSubject$);
  }

  get memberNotFound() {
    return this.storeSnapshot(this.memberNotFound$);
  }

  get schema() {
    return this.storeSnapshot(this.schema$);
  }

  get fullName() {
    return this.storeSnapshot(this.fullName$);
  }

  get resolve() {
    return this.storeSnapshot(this.resolve$);
  }

  get massInsertion() {
    return this.storeSnapshot(this.massInsertion$);
  }
}
